// src/routes/Router.js
import { ProtectedRoute } from './ProtectedRoute';
import { AUTH_ROUTES, APP_ROUTES } from './routes.config';
import FullLayout from '../layouts/full/FullLayout';
import BlankLayout from '../layouts/blank/BlankLayout';
import { RouteWithPermission } from './RouteWithPermission';
import { Navigate } from 'react-router';

export default function createAppRoutes(user) {
  const indexRedirect = APP_ROUTES.find((route) => route.redirect && route.index);
  const pathRedirects = APP_ROUTES.filter((route) => route.redirect && !route.index);
  const appRoutes = APP_ROUTES.filter((route) => !route.redirect);

  const protectedChildren = [
    ...(indexRedirect
      ? [{ index: true, element: <Navigate to={indexRedirect.redirect} replace /> }]
      : []),
    ...appRoutes.map((route) => ({
      ...route,
      element: (
        <RouteWithPermission
          permission={route.permission}
          requireProductMasterAccess={route.requireProductMasterAccess}
          requireYangonAccess={route.requireYangonAccess}
        >
          {route.element}
        </RouteWithPermission>
      ),
    })),
  ];

  return [
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <FullLayout />
        </ProtectedRoute>
      ),
      children: protectedChildren,
    },
    ...pathRedirects.map((route) => ({
      path: route.path,
      element: <Navigate to={route.redirect} replace />,
    })),
    {
      path: '/',
      element: <BlankLayout />,
      children: AUTH_ROUTES,
    },
  ];
}
